import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

const BEARER_TOKEN = 'adminBearerToken';
const TOKEN = 'token';
const RETURN_URL = 'returnUrl';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {
    this.setTokenFromUrl();
  }

  setToken(token: string) {
    localStorage.setItem(BEARER_TOKEN, token);
  }

  getToken() {
    return localStorage.getItem(BEARER_TOKEN);
  }

  removeToken() {
    localStorage.removeItem(BEARER_TOKEN);
  }

  login() {}

  logout() {
    this.removeToken();
    const currentUrl = new URL(window.location.href);
    const loginUrl = new URL(environment.loginUrl);
    loginUrl.searchParams.set(RETURN_URL, currentUrl.toString());

    window.location.replace(loginUrl);
  }

  private setTokenFromUrl(): void {
    if (!this.getToken()) {
      const token = new URLSearchParams(window.location.search).get(TOKEN);

      token && this.setToken(token);
      window.history.replaceState({}, window.document.title, window.location.pathname);
    }
  }
}
